import React from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropzone from 'react-dropzone';

// Components
import * as icons from '../Icons/Icons';

const FileUpload = observer(class FileUpload extends React.Component {
  constructor() {
    super();
    this.handleDrop = this.handleDrop.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.removeFile = this.removeFile.bind(this);
  }

  componentWillMount() {
    this.state = {
      attachment: [],
      dropClass: ''
    }
  }

  handleDrop(file, rejected) {
    const { SessionStore } = this.props.store;
    const { onDrop } = this.props;
    let size = 0;
    let maxFileSize = 4194304;

    if(this.props.maxSize) {
      maxFileSize = this.props.maxSize;
    }

    if(file.length === 0) {

      let dialogContent = this.props.translation.invalid;

      if(this.props.fileType && this.props.fileType === 'application/pdf'){
         dialogContent = this.props.translation.invalid_pdf;
      }

      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    } else {
      file.forEach(function(file){
        if(file.size) {
          size += file.size
        }
      });
    }

    if(this.state.attachment.length + file.length <= 5 && size <= maxFileSize) {
      let attachment = [...this.state.attachment.concat(file)];

      this.setState({
        attachment,
        dropClass: ''
      });

      if(onDrop) {
        onDrop(attachment);
      }
    } else {
      let dialogContent = this.props.translation.limit;

      if(size > 4194304) {
        dialogContent = this.props.translation.too_large;
      }

      SessionStore.showDialog(dialogContent);

      this.setState({
        dropClass: ''
      });
    }
  }

  handleDragEnter() {
    this.setState({
      dropClass: 'file-drop--drag-enter'
    });
  }

  handleDragLeave() {
    this.setState({
      dropClass: ''
    });
  }

  handleInputFocus(e) {
    if (e.type === 'focus') {
      e.target.parentNode.classList.add("dz-input-focus");
    } else {
      e.target.parentNode.classList.remove("dz-input-focus");
    }
  }

  removeFile(i) {
    let attachment = [...this.state.attachment];
    attachment.splice(i, 1);

    this.setState({
      attachment
    });
  }

  deleteFile(file, index) {
    const { ExamStore } = this.props.store;

    if((this.props.exception && this.props.customConfiguration.sid) || !this.props.exception) {
      ExamStore.deleteAttachments.push(file);
    }

    this.removeUploadedFile(index);
  }

  removeUploadedFile(index) {
    const { customConfiguration, exam, exception } = this.props;
    const type = exam.type.toLowerCase();

    if(!exception) {
      if(type !== 'written') {
        exam.configuration.attachments.splice(index, 1);
      } else {
        exam.configuration.examFiles.splice(index, 1);

        console.log(toJS(exam.configuration.examFiles));
      }
    } else {
      if(type !== 'written') {
        customConfiguration.attachments.splice(index, 1);
      } else {
        customConfiguration.examFiles.splice(index, 1);
      }
    }
  }

  render() {
    const { maxSize, translation } = this.props;
    const { SessionStore } = this.props.store;
    const { files, fileType, single } = this.props;

    if(!SessionStore.loading) {
      return(
        <div>
          {
            !this.props.readonly &&
            (
              (
                this.props.single &&
                (this.state.attachment.length === 0 && (!files || files.length === 0))
              ) ||
              !this.props.single
            ) &&

            <Dropzone
              className={`file-drop ${this.state.dropClass}`}
              onDrop={this.handleDrop}
              onDragEnter={this.handleDragEnter}
              onDragLeave={this.handleDragLeave}
              multiple={single ? false : true}
              accept={fileType ? fileType : 'audio/*, image/*, text/*, video/*, application/*, application/octet-stream'}
              maxSize={maxSize ? maxSize : 4194304}
              inputProps={{
                id: 'dz-input-file-upload',
                className: 'dz-input',
                onFocus: this.handleInputFocus,
                onBlur: this.handleInputFocus
              }}
            >
              <label className="file-drop__label">
                {this.props.label ? this.props.label : translation.label}
              </label>

              {this.props.helper &&
                <span className="file-drop__helper">
                  {this.props.helper}
                </span>
              }

              {/* {this.props.onCancel && !files &&
                <button
                  className="btn--link"
                  onClick={this.props.onCancel}
                >
                  {translation.cancel}
                </button>
              } */}
            </Dropzone>
            }

          {(this.state.attachment.length > 0 || (files && files.length > 0)) &&
            <ul className="file-drop__files">
              {/* Existing files */}
              {files && files.length > 0 && files.map(
                (file, i) =>
                <li key={i}>
                  <span>{file.attachmentAwsTitle}</span>

                  <button
                    className="btn--remove"
                    type="button"
                    onClick={() => this.deleteFile(file.attachmentAwsTitle, i)}
                    disabled={this.props.readonly ? true : false}
                  >
                    <icons.iconMinus />
                    <span className="meta">
                      {translation.remove} {file.name}
                    </span>
                  </button>
                </li>
              )}

              {/* Newly added files */}
              {this.state.attachment.map(
                (file, i) =>
                <li key={i}>
                  <span>{file.name}</span>

                  <button
                    className="btn--remove"
                    type="button"
                    onClick={() => this.removeFile(i)}
                    disabled={this.props.readonly ? true : false}
                  >
                    <icons.iconMinus />
                    <span className="meta">
                      {translation.remove} {file.name}
                    </span>
                  </button>
                </li>
              )}
            </ul>
          }
        </div>
      );
    }

    return null;
  }
})

export default translate('FileUpload')(FileUpload);



// WEBPACK FOOTER //
// ./src/app/components/Modules/FileUpload.js